import React, { useMemo } from "react";
import MetricCard from "./MetricCard";
import SectionPanel from "./SectionPanel";
import InfoModal from "./InfoModal";
import { improvementInfo } from "../analyticsInfoContent";
import { COLORS } from "../mockData";

const formatRows = (rows = []) =>
  rows.map((r) => ({
    label: r.label,
    value:
      r.percentage !== undefined ? `${r.value} (${r.percentage}%)` : r.value,
  }));

const ImprovementTracking = ({ data, loading, onCardClick }) => {
  const section = data?.improvementTracking;
  const cards = section?.cards || [];

  const groupedPeriods = useMemo(() => {
    const grouped = {};
    cards.forEach((c) => {
      const key = c.timeRange || "Unknown";
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(c);
    });
    return Object.entries(grouped);
  }, [cards]);

  if (!cards.length && !loading) return null;

  const isMultiPeriod = groupedPeriods.length > 1;

  return (
    <SectionPanel
      title={section?.title || "Improvement Tracking"}
      titleAddon={<InfoModal {...improvementInfo} />}
    >
      <div
        className={
          isMultiPeriod ? "analytics-card-grid-2x3" : "analytics-card-pair"
        }
      >
        {groupedPeriods.map(([period, periodCards]) =>
          periodCards.map((card, i) => (
            <MetricCard
              key={`${period}-${card.label}-${i}`}
              label={card.label}
              period={card.timeRange}
              mainValue={card.displayValue}
              accentColor={
                card.label === "PHQ-9" ? COLORS.phq9 : COLORS.gad7
              }
              labelColor={
                card.label === "PHQ-9" ? COLORS.phq9Label : COLORS.gad7Label
              }
              rows={formatRows(card.rows)}
              onClick={
                onCardClick
                  ? () =>
                      onCardClick({
                        cardType: "improvementTracking",
                        assessmentType: card.label === "PHQ-9" ? "phq9" : "gad7",
                        timeRange: card.timeRange,
                        sectionTitle: section?.title || "Improvement Tracking",
                        cardLabel: card.label,
                      })
                  : undefined
              }
            />
          ))
        )}
      </div>
    </SectionPanel>
  );
};

export default ImprovementTracking;
